import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '../Button/Button';
export const HorizontalTabItem = ({ isActive, label, ...buttonProps }) => {
    const variant = isActive ? 'dark' : 'light';
    const color = isActive ? 'action' : 'grey';
    return (_jsx(Button, { color: color, variant: variant, textVariant: 'b2', ...buttonProps, children: label }));
};
